import React, { useEffect, useState } from "react";
import DropZoneComp from "../DropZoneComp";
import UploadedFiles from "../UploadedFiles";
import useQuotationRequestById from "../../../../../../../store/ReactQueries/procurements/quotationRequests/useQuotationRequestById";
import { FieldErrors } from "../../../../../../../domain/helpers/Errors";
import { QuotationFileInterface } from "../../../../../../../models/ProcurementModule/QuotationFile";
import { QuotationRequestInterface } from "../../../../../../../models/ProcurementModule/QuotationRequest";
import useQuotationRequests from "../../../../../../../store/ReactQueries/procurements/quotationRequests/useQuotationRequests";

interface UploadFilesCompProps {
    mode: 'Show' | 'Add';
    purchaseOrderId: string | undefined;
    open: {
        id: string;
        value: boolean;
    };
    errors?: FieldErrors;
    form: QuotationRequestInterface;
    setForm: React.Dispatch<React.SetStateAction<QuotationRequestInterface>>;
    fileNames: {
        fileUrl: string;
        fileName: string;
    }[];
    setFileNames: React.Dispatch<React.SetStateAction<{
        fileUrl: string;
        fileName: string;
    }[]>>;
}

export const UploadFilesComp: React.FC<UploadFilesCompProps> = ({
    open, form, errors, fileNames, purchaseOrderId,
    setForm, setFileNames,
}) => {

    const { data: purchaseOrderById } = useQuotationRequestById(open.id);
    const { data: quotationRequestsData } = useQuotationRequests(purchaseOrderId, 0, 0);

    const [files, setFiles] = useState<QuotationFileInterface[]>([]);
    const hasApprovedRequest = quotationRequestsData?.some(item => item.isApproved);

    useEffect(() => {
        if (purchaseOrderById && purchaseOrderById.files) setFiles(purchaseOrderById.files);
        else setFiles([]);
    }, [form.id, purchaseOrderById]);


    return <div className="p-4 position-relative d-flex flex-row gap-3 justify-content-between">
        {
            !hasApprovedRequest
            && <DropZoneComp
                form={form}
                files={files}
                errors={errors}
                setForm={setForm}
                setFiles={setFiles}
                fileNames={fileNames}
                setFileNames={setFileNames}
            />
        }
        <UploadedFiles
            form={form}
            files={files}
            errors={errors}
            setForm={setForm}
            setFiles={setFiles}
            hasApprovedRequest={hasApprovedRequest}
        />
    </div>
}
export default UploadFilesComp;